// extracted by mini-css-extract-plugin
var _1 = "SharingDropdown-module__addContainer--YSjm7";
var _2 = "SharingDropdown-module__animateUploadProgressBarWidth--O3ZyA";
var _3 = "SharingDropdown-module__animatedBackground--Xh8y6";
var _4 = "SharingDropdown-module__container--IhFaK";
var _5 = "SharingDropdown-module__linkContainer--ePk5e";
var _6 = "SharingDropdown-module__userContainer--tHQFO";
export { _1 as "addContainer", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "linkContainer", _6 as "userContainer" }
